// 2s delay (2000 ms)
export const IS_LEDGER_OPEN_TIME_DELAY = 2 * 1000;
export const MINIMUM_LEDGER_ACCOUNT_NUMBER = 0;
// TODO : To be modified
export const MAXIMUM_LEDGER_ACCOUNT_NUMBER = 10000;
